import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEftLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 24,
	viewBox: "0 0 34 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 34,
		height: 24,
		rx: 4,
		fill: "#009A5D"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.77148 16H12.3496L12.6152 14.4297H8.9707L9.23633 12.7852H12.5957L12.8613 11.2109H9.50195L9.76758 9.57031H13.4121L13.6777 8H8.09961L6.77148 16ZM13.5605 16H15.4941L16.0254 12.7852H19.2051L19.4707 11.2109H16.291L16.5566 9.57031H20.084L20.3496 8H14.8887L13.5605 16ZM20.7959 9.57031H23.2256L22.1631 16H24.0693L25.1318 9.57031H27.5576L27.8232 8H21.0615L20.7959 9.57031Z",
		fill: "white"
	})]
});
export default SvgEftLogo;
